import type { ModalProps } from './Modal.tsx'

/**
 * 「추가」 창 일곱(작업 · 시료 · 레시피 · 랩웨어 · 사용자 · 보정 기록 · 보충 기록)의 **단 하나의 옵션 조합**(eric 2026-09-30 「새로운 추가 관련된 거..
 * 포맷을 모두 동일하게 해줘」). 넷이 `AddModal` 을 거쳐 이것 하나를 쓴다 — 창마다 크기 · 닫힘 규칙이 갈리던 것을 걷었다
 * (작업만 바깥 누름으로 안 닫혔고, 크기가 `wide` · `lg` 로 둘이었다).
 *
 * - `size: 'wide'` — 머리 · 바닥 고정 + 본문만 스크롤하는 뼈대. 🔴 **폭은 일곱이 한 값**(`--dialog-form-w`)이고
 *   높이는 내용을 따른다(본문 칸이 상한) — `overlay.css` `.a-modal--form`. 종전의 `lg`(본문 칸 94%) · 안의 폭
 *   `narrow`/`full` 두 벌은 걷었다(eric 2026-09-30 「창마다 포맷이 달라.. 다 통일해줘」)
 * - `closeOnBackdrop` — 바깥 누름 · Esc · × 가 전부 닫는다. 🔴 저장 중만 잠긴다(`useModalBusy`)
 * - `initialFocus: 'field'` — 열리면 첫 입력칸
 * - `scope: 'body'` — 🔴 머리줄 · 상시 작업 줄(E-STOP)은 창이 떠 있어도 눌린다(07 §6)
 * - `variant: 'form'` — 추가 창 겉모습(`overlay.css` · `screens/addForm.css`)
 *
 * ⚠ 컴포넌트와 파일을 나눈 것은 한 파일이 컴포넌트만 내보내야 핫리로드가 성립해서다.
 */
export const ADD_MODAL = {
  size: 'wide',
  closeOnBackdrop: true,
  initialFocus: 'field',
  scope: 'body',
  variant: 'form',
} as const satisfies Partial<ModalProps>
